<template>
<div id="app" v-scroll="scrollHandler">
    <!-- <div class="fon"></div> -->
    <app-navbar></app-navbar>
    <div class="container">

        <app-nav :menu="menu" @menu-false="menu = false" @menu-toggle=" menu = !menu"></app-nav>

        <div @click="menu = false">
            <transition name="slide" mode="out-in">
                <router-view></router-view>
            </transition>
        </div>
    </div>
    <div class="for-cart-icon" v-if="cnt && routeName">
        <CartIcon :cnt=cnt></CartIcon>
    </div>

    <div class="forarrow" v-if="arrow" @click="arrowHandler">
        <i class="fa fa-3x fa-arrow-circle-o-up"></i>
    </div>

</div>
</template>

<script>
import AppNav from './components/AppTest'
import AppNavbar from './components/AppNavbar'
import CartIcon from './components/cartIcon'

export default {
    name: 'app',
    mounted() {
        if (localStorage.getItem("cart")) {
            let cart = JSON.parse(localStorage.getItem("cart"))
            cart.forEach(el => {
                this.$store.commit('cart/add', el)
            });

        }
    },
    data() {
        return {
            arrow: false,
            menu: false
        }
    },
    computed: {
        cnt() {
            return this.$store.getters['cart/cnt']
        },
        routeName() {
            if (this.$route.name == 'cart') {
                return false
            }
            return true
        }
    },
    methods: {
        scrollHandler() {
            if (window.scrollY > 350) {
                this.arrow = true
            } else {
                this.arrow = false
            }
        },
        arrowHandler() {
            window.scrollTo(0, 0)
        }
    },
    components: {
        AppNav,
        AppNavbar,
        CartIcon
    }
};
</script>

<style scoped>
.fon {
    background-image: url('../public/img/fon2.jpg');
    z-index: -1;
    opacity: 0.3;
    position: fixed;
    width: 100%;
    height: 100%;

}

.content {
    margin-right: auto;
    margin-left: auto;
}

.forarrow {
    position: fixed;
    bottom: 10px;
    background: #847d9bb0;
    padding: 13px;
    border-radius: 50%;
    color: #fff;
    font-weight: 600;
    left: 5px;
}

.forarrow img {
    width: 100%;
}

.for-cart-icon {
    position: fixed;
    bottom: 33px;
    right: 5px;
    cursor: pointer;
    background: #847d9bbf;
    /*     width: 67px;
    height: 81px; */
    border-radius: 50%;
    padding: 35px;
}

.other {
    min-width: 300px;
}

.slide-enter {}

.slide-enter-active {
    animation: slideIn 0.5s;
}

.slide-enter-to {}

.slide-leave {}

.slide-leave-active {
    animation: slideOut 0.5s;
}

.slide-leave-to {}

@keyframes slideIn {
    from {
        transform: rotateY(90deg);
    }

    to {
        transform: rotateY(0deg);
    }
}

@keyframes slideOut {
    from {
        transform: rotateY(0deg);
    }

    to {
        transform: rotateY(90deg);
    }
}

@media (min-width: 1600px) {
    .container {
        max-width: 1400px;

    }
}
</style>
